import React from "react";
import { Inner } from "./styles.js";
import CarData from "./components/form_car_data/CarData.js";
import CarLocation from "./components/form_car_location/CarLocation.js";
import CarSpecialFeatures from "./components/form_car_special_features/CarSpecialFeatures.js";
import CarSearch from "./components/form_car_search/CarSearch.js";

const Step1Car = ({ nextMainStep, step1Car, setStep1Car, isMobile }) => {
	const renderStep1Car = () => {
		switch (step1Car) {
			case 0:
				return (
					<CarSearch nextSubStep={handleSubStepSubmit} isMobile={isMobile} />
				);
			case 1:
				return (
					<CarData nextSubStep={handleSubStepSubmit} isMobile={isMobile} />
				);
			case 2:
				return (
					<CarLocation nextSubStep={handleSubStepSubmit} isMobile={isMobile} />
				);
			case 3:
				return (
					<CarSpecialFeatures
						nextSubStep={handleSubStepSubmit}
						nextMainStep={nextMainStep}
						isMobile={isMobile}
					/>
				);
			default:
				return null;
		}
	};

	const handleSubStepSubmit = (step) => {
		setStep1Car(step);
	};

	return <Inner>{renderStep1Car()}</Inner>;
};

export default Step1Car;
